<template>
  <div id="admin_featured_promotions_list">
    <CardedTable :items="items" :headers="headers">
      <template v-slot:[`item.promotion.expiry`]="{ item }">
        <span
          class="red--text"
          v-if="item.promotion.expiry == 'expired' && parseInt(item.promotion.has_been_ended) == 0"
          ><b>Expired</b></span
        >
        <span class="red--text" v-if="parseInt(item.promotion.has_been_ended) == 1"
          ><b>Ended</b></span
        >
        <span
          class="warning--text"
          v-if="item.promotion.expiry == 'pending' && parseInt(item.promotion.has_been_ended) == 0"
          ><b>Not Yet</b></span
        >
        <span
          class="success--text"
          v-if="item.promotion.expiry == 'live' && parseInt(item.promotion.has_been_ended) == 0"
          ><b>Happening</b></span
        >
      </template>
      

      <template v-slot:[`item.actions`]="{ item }">
        <v-btn @click="on_view_item(item)" x-small rounded text color="success">
          <v-icon>mdi-eye</v-icon> View
        </v-btn>
        <v-btn @click="on_edit_item(item)" x-small rounded text color="warning" class="ml-2">
          <v-icon>mdi-pen</v-icon> Edit
        </v-btn>
        <v-btn @click="on_delete_item(item)" x-small rounded text color="warning" class="ml-2">
          <v-icon>mdi-trash-can</v-icon> Delete
        </v-btn>
      </template>
    </CardedTable>
  </div>
</template>

<script>
import CardedTable from "../../../components/CardedTable";
import ServerClient from "../../../lib/ServerClient";
import Utils from "../../../lib/Utils";
export default {
  name: "AdminPromotionsFeatured",
  components: {
    CardedTable,
  },
  props: {
    is_loading: {
      type: Boolean,
      default: false,
    },
    user: {
      type: Object,
      default: () => {
        return ServerClient.Login.get_logged_in_user();
      },
    },
  },
  data: () => {
    return {
      _user: null,
      items: [],
      headers: [
        {
          text: "Title",
          align: "start",
          sortable: true,
          value: "promotion.title",
          filterable: true,
        },
        // {
        //   text: "Business",
        //   align: "start",
        //   sortable: false,
        //   value: "business.name",
        //   filterable: true,
        // },
        {
          text: "Platform",
          align: "center",
          sortable: true,
          value: "platform",
          filterable: true,
        },
        {
          text: "Page",
          align: "center",
          sortable: true,
          value: "page",
          filterable: true,
        },
        {
          text: "Section",
          align: "start",
          sortable: true,
          value: "section",
          filterable: true,
        },
        { text: "", value: "actions", sortable: false, align: "end" },
      ],
      indexed_businesses: {},
    };
  },
  methods: {
    load_items() {
      this.$emit("on-show-loader");
      ServerClient.Promotions.get_featured_promotions(
        {},
        (res) => {
          this.$emit("on-hide-loader");
          var php_time_now = parseFloat(Utils.date_str_to_php_time(""));
          //console.log("php_time_now:", res);
          var temp = [];
          for (var index = 0; index < res.length; index++) {
            var ft_promotion = res[index];
            ft_promotion.promotion.expiry = php_time_now;
            if (
              php_time_now <
              parseFloat(ft_promotion.promotion.starts_on_timestamp)
            ) {
              ft_promotion.promotion.expiry = "pending";
            } else if (
              php_time_now >=
                parseFloat(ft_promotion.promotion.starts_on_timestamp) &&
              php_time_now <=
                parseFloat(ft_promotion.promotion.ends_on_timestamp)
            ) {
              promotion.expiry = "live";
            } else if (php_time_now > parseFloat(ft_promotion.promotion.ends_on_timestamp)) {
              ft_promotion.promotion.expiry = "expired";
            }
            temp.push(ft_promotion);
          }
          this.items = temp;
        },
        (errors) => {
          this.$emit("on-hide-loader");
          console.log(
            "Errors while loading featured prmomotions on admin featured promotions list",
            errors
          );
        }
      );
    },
    on_view_item(item) {
      this.$router.push("/admin/promotions/list/view/" + item.promotion.id);
    },
    on_edit_item(item){
      this.$router.push("/admin/promotions/edit/featured/" + item.id);
    },
    on_delete_item(item){
      this.$router.push("/admin/promotions/delete/featured/" + item.id);
    }
  },
  mounted() {
    this._user = ServerClient.Login.get_logged_in_user();
    this.$emit("set-page-attributes", {
      title: "List Of Featured Promotions",
      crumps: [
        {
          text: "Admin",
          disabled: false,
          href: "/admin",
        },
        {
          text: "Promotions",
          disabled: false,
          href: "/admin/promotions",
        },
        {
          text: "Featured",
          disabled: true,
          href: "/admin/promotions/featured",
        },
      ],
    });
    this.load_items();

    var options = {
      offset: 50,
      duration: 1000,
      easing: "easeInOutCubic",
    };
    this.$vuetify.goTo("#admin_featured_promotions_list", options);
  },
};
</script>